import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UserService} from '../../shared/services/user/user.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {StatesService} from '../../shared/services/state/states.service';
import {Subscription} from 'rxjs/index';
import {ToastrService} from 'ngx-toastr';
import {AuthenticationService} from '../../shared/services/authentication/authentication.service';
import {ReferentialService} from '../../shared/services/referential/referential.service';
import {TranslateService} from '@ngx-translate/core';
import {AbstractMatTable} from '../../shared/classes/mat-table/abstract-mat-table';
import {CrudConstants} from '../../shared/constants/crud.constants';
import CRUD_MODE = CrudConstants.CRUD_MODE;
import {IconService} from '../../shared/services/icon/icon.service';

@Component({
  selector: 'app-user',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent extends AbstractMatTable implements OnInit, OnDestroy {

  readonly CRUD_MODE = CRUD_MODE;
  public activeUser: boolean = true;
  public userRoles: any[];
  public roleSelected: string = '';
  userSubscription: Subscription;
  reloadUserListSubscription: Subscription;

  constructor(private userService: UserService,
              public statesService: StatesService,
              private toastr: ToastrService,
              private authenticationService: AuthenticationService,
              private referentialService: ReferentialService,
              private translate: TranslateService,
              public iconService: IconService) {
    super();
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.userRoles = this.referentialService.getUserRolesForLevelAdmin();
    this.getUsers();
    this.userSubscription = this.statesService.stateLevelChangedSubject
      .subscribe(() => this.getUsers()
      );
    this.reloadUserListSubscription = this.statesService.reloadListUser
      .subscribe(() => this.getUsers()
      );
  }

  filterListByUserRole(role: string) {
    if (this.roleSelected !== role) {
      this.roleSelected = role;
    } else {
      this.roleSelected = '';
    }
    this.getUsers();
  }

  getActiveTextForSlider() {
    let value: string = '';
    this.translate.get(this.activeUser ? 'USER_ACTIVE' : 'USER_INACTIVE').subscribe((text: string) => {
      value = text;
    });
    return value;
  }

  sendPasswordEmailToUser(email: string) {
    this.showSpinner = true;
    this.authenticationService.initPassword(email).subscribe((data: any) => {
      this.toastr.success(this.translate.instant('EMAIL_SENT_TO') + email, this.translate.instant('SUCCESS'));
      this.showSpinner = false;
    });
  }

  reLoadList() {
    this.activeUser = !this.activeUser;
    this.statesService.reloadListUser.next();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.reloadUserListSubscription.unsubscribe();
  }

  private getUsers() {
    this.setMatTable(this.userService.getUsers(this.statesService.stateLevel, this.activeUser, this.roleSelected),
      ['id', 'level', 'email', 'roles', 'lastname', 'firstname', 'phone', 'last_login', 'action']);
  }
}
